export const ADDITIONAL_LOGGING_FIELDS_GROUP_ID =
  'additionalLoggingFieldsGroup';
export const ADDITIONAL_LOGGING_FIELDS_FIELD_ID =
  'additionalLoggingFieldsField';
export const REQUIRE_ADDITIONAL_CALL_LOG_FIELDS_KEY =
  'requireAdditionalCallLogFields';
export const SELECTION_LIMIT = 3;
